export const GET_LIST_MY_BUSINESS_WATCHER = 'GET_LIST_MY_BUSINESS_WATCHER';
export const GET_LIST_MY_BUSINESS_SUCCESS = 'GET_LIST_MY_BUSINESS_SUCCESS';
export const GET_LIST_MY_BUSINESS_FAILED = 'GET_LIST_MY_BUSINESS_FAILED';
